import Header from "../components/sections/Header";
import Hero from "../components/sections/Hero";
import StatsRibbon from "../components/sections/StatsRibbon";
import Diferenciais from "../components/sections/Diferenciais";
import Processo from "../components/sections/Processo";
import Cases from "../components/sections/Cases";
import Depoimentos from "../components/sections/Depoimentos";
import GrupoMetier from "../components/sections/GrupoMetier";
import ContactCTA from "../components/sections/ContactCTA";
import Footer from "../components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#FAFAFA] text-[#1C1C1C]">
      <Header />
      <Hero />
      <StatsRibbon />
      <Diferenciais />
      <Processo />
      <Cases />
      <Depoimentos />
      <GrupoMetier />
      <ContactCTA />
      <Footer />
    </main>
  );
}
